import { Pipe, PipeTransform } from '@angular/core';
import { ReplyType } from '@app-types/enums/ReplyType';

@Pipe({
  name: 'emailReply',
  standalone: true,
})
export class EmailReplyPipe implements PipeTransform {
  transform(value: ReplyType, replyDateTime: boolean): string {
    switch (value) {
      case ReplyType.Reply:
        return replyDateTime ? 'replyDone' : 'replyWait';
      case ReplyType.ReplyAll:
        return replyDateTime ? 'replyDone' : 'replyWait';
      case ReplyType.Forward:
        return replyDateTime ? 'forwardDone' : 'forwardWait';
    }
    return '';
  }
}
